var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMatchRoute)?_c('div',{staticClass:"headerBox"},[_vm._v(" "+_vm._s(_vm.isMode2 ? '作文智评助手' : '作文灵感助手')+" ")]):_vm._e(),_c('div',{staticClass:"AllBox",class:{ 'HomeBox': _vm.isMatchRoute }},[_c('router-view')],1),(_vm.isMatchRoute)?_c('TabBox'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }